import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 10px 10px;
  width: 100%;
  @media (max-width: 600px){
    flex-direction: column;
  }
`;

export const WrapperHeaderDash = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 10px;
  width: 50%;
  @media (max-width: 600px){
    flex-direction: column;
  }
`;

export const DashContainer = styled.div`
  background:#ffffff;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  color: #000000;

  position: relative;

  display: flex;
  align-items: center;

  & + div{
      margin-top: 12px;
    }

  input{
    width: 22vw;
    flex: 1;
    background: transparent;
    border: 0;
    text-align: center;
      font-size: 12px;
      color: #000000;

    &::placeholder{
      text-align: center;
      font-size: 12px;
      color: #000000;
    }
  }

  span{
      font-size: 14px;
      color: var(--color-red);
      text-align: left;
      /* display: none; */
    }
`;

export const Img = styled.img`
  width: 180px;
  height: 80px;
  margin: 0 20px;
`;

export const User = styled.div`
    background-color: blue;
    color: white;
`;

export const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;

    input {
      background: var(--color-white);
      border-radius: 4px;
      padding: 12px 16px;
      width: 100%;
      border: 1px solid var(--color-border);
      color: var(--color-gray);
      font-size: 14px;
      height: 40px;

      &::placeholder {
        color: #666360;
      }

      &:focus {
        border-color: var(--color-grey);
        outline: none;
      }
    }
  }
`;